import React from 'react';
export function Guarantee() {
  return <section className="w-full bg-[#00c853] px-5 py-16 sm:px-8" data-id="element-128" data-mp="1qac7xuu2siv8">
      <div className="mx-auto w-full max-w-2xl rounded-2xl bg-white px-6 py-10 text-center shadow-xl sm:px-10" data-id="element-129" data-mp="1o4f0oolspeck">
        <div className="flex items-center justify-center gap-3" data-id="element-130" data-mp="2223kdt44mfg1">
          <span className="rounded-full bg-[#00c853] px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-wider text-white" data-id="element-131" data-mp="1x3tn9cyud4rs">
            ✔ Zero risk
          </span>
          <span aria-hidden="true" className="text-4xl" data-id="element-132" data-mp="19cefv5s7jx9o">
            🛡️
          </span>
        </div>

        <h2 className="mt-5 text-3xl font-extrabold tracking-tight text-neutral-900 sm:text-4xl" data-id="element-133" data-mp="14dtfn6cyhdl8">
          7-Day <span className="text-[#00c853]" data-id="element-134" data-mp="1edu23164g9tn">Guarantee</span>
        </h2>

        <p className="mt-4 text-sm text-neutral-600" data-id="element-135" data-mp="1ecizv5sbra4n">
          Open everything. Check everything. Use the material.
        </p>

        <p className="mt-6 text-xl font-extrabold leading-snug text-neutral-900 sm:text-2xl" data-id="element-136" data-mp="lp6bcq2lss8p">
          Try Netball Ready 360 risk-free. If you're not satisfied,{' '}
          <span className="text-[#00c853]" data-id="element-137" data-mp="oz9mozqlp9l1">
            we'll refund you 100%, no questions asked.
          </span>
        </p>

        <p className="mt-5 text-xs font-bold uppercase tracking-widest text-neutral-600" data-id="element-138" data-mp="ypb81jrkkdw9">
          No questions asked.
        </p>

        <p className="mt-7 inline-block rounded-full border border-[#00c853]/40 bg-[#00c853]/10 px-5 py-2.5 text-xs font-extrabold uppercase tracking-wider text-[#00a344]" data-id="element-139" data-mp="12r6cgx4sr7e9">
          Refund rate below 1%
        </p>
      </div>
    </section>;
}